import type { OnboardingV2Variant } from '@/app-shell/flags/growth-flags';
import { type ErrorSeverity } from '@heidi/analytics/events';
import type { ErrorType, OnboardingErrorStep } from '@heidi/growth/contracts';
import { type ErrorSurface } from '@heidi/templates/contracts';

export enum OnboardingErrorFlow {
  SCRIBE_LED = 'scribe_led',
  STANDARD = 'standard',
  EVIDENCE = 'evidence',
}

export enum OnboardingWizardVersion {
  V1 = 'v1',
  V2 = 'v2',
}

export type OnboardingErrorViewedEventProps = {
  wizard_version?: OnboardingWizardVersion;
  flow?: OnboardingErrorFlow;
  step: OnboardingErrorStep | string;
  error_type: ErrorType | string;
  error_code?: string;
  error_message: string;
  severity: ErrorSeverity;
  http_status_code?: number;
  endpoint?: string;
  country?: string;
  language?: string;
  /** A/B variant the user was bucketed into for the onboarding experiment. */
  onboarding_variant?: OnboardingV2Variant;
};

/** The closed set from `CaptureOrigin::wire_value` in Rust. */
export const DESKTOP_CAPTURE_ORIGINS = ['online', 'offline_recording'] as const;

/** What the desktop IPC error event reports as `capture_origin`. */
export type DesktopCaptureOriginProp =
  | (typeof DESKTOP_CAPTURE_ORIGINS)[number]
  | 'absent'
  | 'unrecognised';

export type ErrorViewedEventProps = {
  surface: ErrorSurface | string;
  screen: string;
  error_type: ErrorType | string;
  error_code?: string;
  error_message: string;
  /** Desktop IPC only: which recorder raised the error. */
  capture_origin?: DesktopCaptureOriginProp;
  /** Desktop IPC only: the Rust message's length; the text itself is never sent. */
  message_length?: number;
  severity: ErrorSeverity;
  http_status_code?: number;
  endpoint?: string;
  country?: string;
  language?: string;
};
